blue.ready('androidAppBanner', '#android-app-banner', androidAppBanner => {
	const dismiss = androidAppBanner.querySelector('.dismiss');

	blue.meth.addEvents(dismiss, 'click touch', function() {
		blue.meth.cookie.set('androidBannerCookie', true, '/', 90);
		androidAppBanner.style.display = 'none';
	});
});